const initialState = {
  days: [],
  enrichedDays: {},
  completedLessons: [],
  totalStudyDaysCount: 0,
  totalRemainingLessonsCount: 0,
  totalRemainingSeconds: 0,
  completionDate: null,
  truncated: false,
  courseId: null,
};

export default function studyPlanReducer(state = initialState, action) {
  switch (action.type) {
    case "STUDY_PLAN_COMPUTED":
      return { ...state, ...action.payload };
    case "STUDY_PLAN_CLEARED":
      return initialState;
    default:
      return state;
  }
}
